import React from 'react';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

export const getProductCtaLabel = (
  isAssortmentTestProductDisabled,
  isOutOfStock
) => {
  if (isAssortmentTestProductDisabled) {
    return (
      <FormattedMessage
        id="global_cta.product_unavailable"
        defaultMessage="Product Unavailable"
      />
    );
  }
  if (isOutOfStock) {
    return (
      <FormattedMessage
        id="global_cta.out_of_stock"
        defaultMessage="Out of Stock"
      />
    );
  }
  return (
    <FormattedMessage id="site_pdp.add_to_cart" defaultMessage="Add to Bag" />
  );
};
